import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, setAnalyticsSuppressed, trackPageView } from "@/lib/analytics";
import { useAuth } from "@/contexts/AuthContext";
import { useIsAdmin } from "@/hooks/useIsAdmin";

export function RouteAnalytics() {
  const location = useLocation();
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, isLoading: adminLoading, isError: adminCheckFailed } = useIsAdmin();
  const analyticsReady = !authLoading && (!user || (!adminLoading && !adminCheckFailed));

  useEffect(() => {
    if (!analyticsReady) return;
    setAnalyticsSuppressed(isAdmin);
    if (!isAdmin) initAnalytics();
  }, [analyticsReady, isAdmin]);

  useEffect(() => {
    if (!analyticsReady || isAdmin) return;
    // Let route-level SEO effects settle before capturing the title. Query-string
    // changes (for example Quick ID filters) are product events, not new pageviews.
    const timer = window.setTimeout(() => trackPageView(location.pathname), 0);
    return () => window.clearTimeout(timer);
  }, [analyticsReady, isAdmin, location.pathname]);

  return null;
}
